/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2024, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="M22.5 6.5c0 2.7614-2.2386 5-5 5s-5-2.2386-5-5 2.2386-5 5-5c1.4925 0 2.8323.654 3.7484 1.691L18 6.4392l-1.4697-1.4696a.75.75 0 0 0-1.0606 1.0607l2 2L18 8.5606l.5303-.5304 3.5465-3.5465A4.9824 4.9824 0 0 1 22.5 6.5Zm1.5 0c0 2.406-1.3071 4.5065-3.25 5.6304V19c0 2.0711-1.6789 3.75-3.75 3.75H5c-2.071 0-3.75-1.6789-3.75-3.75V5c0-2.071 1.679-3.75 3.75-3.75h8.6668C14.7415.464 16.0666 0 17.5 0 21.0899 0 24 2.9101 24 6.5ZM19.25 19v-6.2383A6.505 6.505 0 0 1 17.5 13a6.5046 6.5046 0 0 1-1.8459-.2658.7592.7592 0 0 1-.1541.0158h-9a.75.75 0 0 1 0-1.5h6.5629c-.9799-.9157-1.6762-2.131-1.9428-3.5H6.5a.75.75 0 0 1 0-1.5h4.5047a6.4661 6.4661 0 0 1 1.1855-3.5H5C3.7574 2.75 2.75 3.7574 2.75 5v14c0 1.2426 1.0074 2.25 2.25 2.25h12c1.2426 0 2.25-1.0074 2.25-2.25ZM6.5 16.25a.75.75 0 0 0 0 1.5h5a.75.75 0 0 0 0-1.5h-5Z"
    clipRule="evenodd"
  />,
  'MenuApprovals'
);
